import StudentPracQuiz from './StudentPracQuiz';

export default StudentPracQuiz;
